import axios from "axios";

import { parseTaskModel } from "../../task/model";

import { MergedAppointments } from "./models";

export class AppointmentMergingApi {
    private readonly apiUrl = "/api/Appointment";

    public async getMergedAppointments(
        baseAppointmentId: string): Promise<MergedAppointments> {

        const response = await axios.get<MergedAppointments>(`${this.apiUrl}/MergedAppointments/${baseAppointmentId}`);

        return {
            mergedAppointmentDetails: response.data.mergedAppointmentDetails.map((appointment) => {
                return {
                    task: parseTaskModel(appointment.task),
                    appointment: appointment.appointment,
                    employeePersonalReferenceNumber: appointment.employeePersonalReferenceNumber
                };
            }),
            cancelledAppointmentsDetails: response.data.cancelledAppointmentsDetails.map((appointment) => {
                return {
                    task: parseTaskModel(appointment.task),
                    appointment: appointment.appointment,
                    employeePersonalReferenceNumber: appointment.employeePersonalReferenceNumber
                };
            }),
        };
    }
}
